/**
 * Pure helpers for `BrowseWaitlistState` (the plan-317 browse gate surface).
 * Sibling module per the Fast Refresh rule in `frontend/consumer/CLAUDE.md`.
 */

/**
 * Joins the live-metro display names the backend returns on an
 * `area_not_launched` browse response into one English list:
 *   ["A"]           → "A"
 *   ["A", "B"]      → "A and B"
 *   ["A", "B", "C"] → "A, B, and C"
 * Blank entries are dropped. An empty result means the caller must render
 * NO "Sill is live in …" sentence — the names come only from the server, so
 * nothing here ever invents a market.
 */
export function joinAreaNames(names: readonly string[] | undefined): string {
  const clean = (names ?? []).map((n) => n.trim()).filter((n) => n.length > 0);
  if (clean.length === 0) return "";
  if (clean.length === 1) return clean[0];
  if (clean.length === 2) return `${clean[0]} and ${clean[1]}`;
  return `${clean.slice(0, -1).join(", ")}, and ${clean[clean.length - 1]}`;
}
